module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fill-height": "",
      "container--fluid": ""
    }
  }, [_c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "end",
      "align": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "right"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.billingFilterItems,
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "dense": "",
      "label": "Billing Names"
    },
    on: {
      "change": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.billingSelectedFilter),
      callback: function($$v) {
        _vm.billingSelectedFilter = $$v
      },
      expression: "billingSelectedFilter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3",
      "align": "right"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignFilterItems,
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "dense": "",
      "label": "Campaign Names"
    },
    on: {
      "change": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.campaignSelectedFilter),
      callback: function($$v) {
        _vm.campaignSelectedFilter = $$v
      },
      expression: "campaignSelectedFilter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1",
      "align": "left"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.campaignReportHeaders,
      "items": _vm.campaignReportData,
      "single-expand": "",
      "expanded": _vm.expanded,
      "item-key": "id",
      "show-expand": ""
    },
    on: {
      "update:expanded": function($event) {
        _vm.expanded = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.clientName",
      fn: function(ref) {
        var item = ref.item;

        return [(item.campaignGroup) ? _c('v-icon', [_vm._v("mdi-domain")]) : _vm._e(), _vm._v(" " + _vm._s(item.clientName) + "\n            ")]
      }
    }, {
      key: "item.IOAmount",
      fn: function(ref) {
        var item = ref.item;

        return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "primary",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
      }
    }, {
      key: "item.cogs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-icon', {
          staticClass: "currency",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n            ")]
      }
    }, {
      key: "item.revenue",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-chip', {
          staticClass: "ma-1",
          attrs: {
            "color": "green",
            "small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          staticClass: "mr-0",
          attrs: {
            "small": "",
            "left": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenue)))])], 1)]
      }
    }, {
      key: "item.avgInfluencerRatings",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-center"
        }, [_c('v-rating', {
          staticClass: "v-rating-button",
          attrs: {
            "readonly": "",
            "dense": "",
            "small": "",
            "length": "5"
          },
          model: {
            value: (item.avgInfluencerRatings),
            callback: function($$v) {
              _vm.$set(item, "avgInfluencerRatings", $$v)
            },
            expression: "item.avgInfluencerRatings"
          }
        })], 1)]
      }
    }, {
      key: "item.avgClientRatings",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-center"
        }, [_c('v-rating', {
          staticClass: "v-rating-button",
          attrs: {
            "readonly": "",
            "dense": "",
            "small": "",
            "length": "5"
          },
          model: {
            value: (item.avgClientRatings),
            callback: function($$v) {
              _vm.$set(item, "avgClientRatings", $$v)
            },
            expression: "item.avgClientRatings"
          }
        })], 1)]
      }
    }, {
      key: "item.amountPaid",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-icon', {
          staticClass: "currency",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amountPaid)) + "\n            ")]
      }
    }, {
      key: "expanded-item",
      fn: function(ref) {
        var headers = ref.headers;
        var item = ref.item;

        return [(item.influencers) ? _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "payout-table-small elevation-1",
          attrs: {
            "headers": _vm.detailsHeaders,
            "items": item.influencers,
            "hide-default-footer": ""
          },
          scopedSlots: _vm._u([{
            key: "item.handle",
            fn: function(ref) {
              var item = ref.item;

              return [_c('a', {
                attrs: {
                  "target": "_blank",
                  "href": 'https://instagram.com/' + item.handle
                }
              }, [_vm._v("@" + _vm._s(item.handle))])]
            }
          }, {
            key: "item.amount",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                  ")]
            }
          }, {
            key: "item.influencerRating",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "text-center"
              }, [_c('v-rating', {
                staticClass: "v-rating-button",
                attrs: {
                  "readonly": "",
                  "dense": "",
                  "small": "",
                  "length": "5"
                },
                model: {
                  value: (item.influencerRating),
                  callback: function($$v) {
                    _vm.$set(item, "influencerRating", $$v)
                  },
                  expression: "item.influencerRating"
                }
              })], 1)]
            }
          }], null, true)
        })], 1) : _c('td', {
          staticStyle: {
            "border": "none",
            "padding": "20px"
          },
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          key: _vm.dataTableKey,
          staticClass: "elevation-1",
          attrs: {
            "headers": _vm.campaignReportHeaders,
            "items": item.campaigns,
            "single-expand": "",
            "expanded": _vm.expanded2,
            "show-expand": ""
          },
          on: {
            "update:expanded": function($event) {
              _vm.expanded2 = $event
            }
          },
          scopedSlots: _vm._u([{
            key: "item.IOAmount",
            fn: function(ref) {
              var item = ref.item;

              return [(item.IOAmount === 0) ? _c('span', [_vm._v("N/A")]) : _c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "primary",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.IOAmount)))])], 1)]
            }
          }, {
            key: "item.cogs",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n                  ")]
            }
          }, {
            key: "item.revenue",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-chip', {
                staticClass: "ma-1",
                attrs: {
                  "color": "green",
                  "small": "",
                  "text-color": "white"
                }
              }, [_c('v-icon', {
                staticClass: "mr-0",
                attrs: {
                  "small": "",
                  "left": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.revenue)))])], 1)]
            }
          }, {
            key: "item.avgInfluencerRatings",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "text-center"
              }, [_c('v-rating', {
                staticClass: "v-rating-button",
                attrs: {
                  "readonly": "",
                  "dense": "",
                  "small": "",
                  "length": "5"
                },
                model: {
                  value: (item.avgInfluencerRatings),
                  callback: function($$v) {
                    _vm.$set(item, "avgInfluencerRatings", $$v)
                  },
                  expression: "item.avgInfluencerRatings"
                }
              })], 1)]
            }
          }, {
            key: "item.avgClientRatings",
            fn: function(ref) {
              var item = ref.item;

              return [_c('div', {
                staticClass: "text-center"
              }, [_c('v-rating', {
                staticClass: "v-rating-button",
                attrs: {
                  "readonly": "",
                  "dense": "",
                  "small": "",
                  "length": "5"
                },
                model: {
                  value: (item.avgClientRatings),
                  callback: function($$v) {
                    _vm.$set(item, "avgClientRatings", $$v)
                  },
                  expression: "item.avgClientRatings"
                }
              })], 1)]
            }
          }, {
            key: "item.vertical",
            fn: function(ref) {
              var item = ref.item;

              return _vm._l((item.vertical), function(item, index) {
                return _c('v-chip', {
                  key: index,
                  staticClass: "ma-1",
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("\n                          " + _vm._s(item.name) + "\n                      ")])
              })
            }
          }, {
            key: "item.amountPaid",
            fn: function(ref) {
              var item = ref.item;

              return [_c('v-icon', {
                staticClass: "currency",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amountPaid)) + "\n                  ")]
            }
          }, {
            key: "expanded-item",
            fn: function(ref) {
              var headers = ref.headers;
              var item = ref.item;

              return [_c('td', {
                staticStyle: {
                  "border": "none",
                  "padding": "20px"
                },
                attrs: {
                  "colspan": headers.length
                }
              }, [_c('v-data-table', {
                staticClass: "payout-table-small elevation-1",
                attrs: {
                  "headers": _vm.detailsHeaders,
                  "items": item.influencers,
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u([{
                  key: "item.handle",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('a', {
                      attrs: {
                        "target": "_blank",
                        "href": 'https://instagram.com/' + item.handle
                      }
                    }, [_vm._v("@" + _vm._s(item.handle))])]
                  }
                }, {
                  key: "item.amount",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('v-icon', {
                      staticClass: "currency",
                      attrs: {
                        "small": ""
                      }
                    }, [_vm._v("mdi-currency-usd")]), _vm._v(_vm._s(_vm._f("thousandSeprator")(item.amount)) + "\n                        ")]
                  }
                }, {
                  key: "item.influencerRating",
                  fn: function(ref) {
                    var item = ref.item;

                    return [_c('div', {
                      staticClass: "text-center"
                    }, [_c('v-rating', {
                      staticClass: "v-rating-button",
                      attrs: {
                        "readonly": "",
                        "dense": "",
                        "small": "",
                        "length": "5"
                      },
                      model: {
                        value: (item.influencerRating),
                        callback: function($$v) {
                          _vm.$set(item, "influencerRating", $$v)
                        },
                        expression: "item.influencerRating"
                      }
                    })], 1)]
                  }
                }], null, true)
              })], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b229900e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/payoutsReport.vue
// module id = 2271
// module chunks = 0